import { render } from "./PosotionImgContentRight.vue?vue&type=template&id=3b918c0e&scoped=true"
import script from "./PosotionImgContentRight.vue?vue&type=script&lang=js"
export * from "./PosotionImgContentRight.vue?vue&type=script&lang=js"

import "./PosotionImgContentRight.vue?vue&type=style&index=0&id=3b918c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b918c0e"]])

export default __exports__